import { useMutation } from '@apollo/client';
import { IAccreditationApplication } from '../interfaces/IAccreditationApplication';
import {
    AccreditationApplicationPaymentCommandInput,
    AccreditationApplicationPaymentCompleteCommandInput,
} from '../graphql/__generated__/graphql';
import {
    ACCREDITATION_APPLICATION_PAYMENT,
    ACCREDITATION_APPLICATION_PAYMENT_RESPONSE,
} from '../graphql/payment/mutations';
import { useState } from 'react';

export const useAccreditationPayments = () => {
    const [error, setError] = useState(false);
    const [accreditationPayment] = useMutation(ACCREDITATION_APPLICATION_PAYMENT);
    const [accreditationPaymentResponseMutation] = useMutation(
        ACCREDITATION_APPLICATION_PAYMENT_RESPONSE
    );

    const initialiseApplicationPayment = async (application: IAccreditationApplication) => {
        return accreditationPayment({
            variables: {
                command: {
                    redirectUri: '/accreditation/apply',
                    applicationId: application.accreditationApplicationId,
                } as AccreditationApplicationPaymentCommandInput,
            },
        })
            .then(async (response: any) => {
                return response.data.accreditationApplicationPayment;
            })
            .catch((e: any) => {
                console.error('Failed to initialise.', e);
                setError(true);
            });
    };

    // Data required in command but not actually utilised server-side
    // so might be able to scrap it
    interface BillingInfo {
        created?: string;
        id?: string;
        status?: string;
    }

    const finaliseApplicationPayment = (
        application: IAccreditationApplication,
        billingRequestJson: string,
        billingInfo?: BillingInfo
    ) => {
        return accreditationPaymentResponseMutation({
            variables: {
                command: {
                    applicationId: application.accreditationApplicationId,
                    billingRequestJson,
                    ...billingInfo,
                } as AccreditationApplicationPaymentCompleteCommandInput,
            },
        });
    };

    return {
        operations: {
            initialiseApplicationPayment,
            finaliseApplicationPayment,
        },
        models: {
            error,
        },
    };
};
